var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isWeiXinBrowser,
          expression: "isWeiXinBrowser",
        },
      ],
      staticStyle: { width: "100%", height: "100%" },
      attrs: {
        "element-loading-spinner": "1",
        "element-loading-background": "rgba(0, 0, 0, 1)",
      },
    },
    [
      !_vm.isWeiXinBrowser && _vm.live_check
        ? _c("Student", { ref: "component" })
        : !_vm.isWeiXinBrowser && !_vm.live_check
        ? _c("DeviceCheck", {
            attrs: { type: "student", stepsIndex: 1 },
            on: { changeLiveCheck: _vm.changeLiveCheck },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/index.vue?vue&type=template&id=1633375b&scoped=true&
// module id = null
// module chunks = 